import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { URL_DEFAULT_REDIRECT } from 'src/utils/constants/auth';
import { loadDecimalPlaces } from 'src/services/decimalPlacesLoader';

const PrivateRoute = ({ component: Component }) => {
  const loggedIn = useSelector(state => state.auth.token !== null);

  useEffect(() => {
    if (loggedIn) {
      loadDecimalPlaces();
    }
  }, [loggedIn]);

  if (!loggedIn) {
    window.location.replace(URL_DEFAULT_REDIRECT);
    return null;
  }

  return <Component />;
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func
  ])
};

export default PrivateRoute;
